import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import SettingsInfo from '../components/SettingsInfo';

const Settings = () => {
    return (
        <div className="d-flex entire-bg-color">
            <Sidebar />

            <div className="flex-grow-1">
                <DashboardNavbar />
                
                <div style={{marginTop: '70px'}}></div>
                <SettingsInfo/>
            </div>
        </div>
    );
};

export default Settings;